// socket 连接状态
const CMD = {
  C_ONCONNECT: "C01", // 连接触发
  C_FAIL: "C02", // 连接失败
  C_SUCCESS: "C03", // 连接成功
  C_KICKOUT: "C04" // 踢出
};

const COMMAND_TYPE_CMD = {
  CT_POINT: "P01", // 点对点推送
  CT_INGROUP: "P02", // 群组内推送
  CT_RADIO: "P03" // 全服广播推送
};

// 设备类型  不一样
const DEVICE = {
  WINDOWS: 1,
  MAC: 2,
  IOS: 3,
  ANDROID: 4,
  WEB: 5
};

export default {
  CMD,
  COMMAND_TYPE_CMD,
  DEVICE
};
